import React, { useState, useEffect } from 'react';
import NavBar from '../../../components/NavBar';
import SinanHub from '../../../components/sinan/SinanHub';
import Cookies from 'js-cookie';

const SinanHome = () => {
	/* const [showAlert, setShowAlert] = useState(false); */

	useEffect(() => {}, []);

	return (
		<div className='flex flex-col min-h-screen '>
			<NavBar />
			<div>
				<SinanHub />
			</div>
		</div>
	);
};

export default SinanHome;
